import * as types from './mutation-types'
export const loadQvctSurveyReportStats = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/qvct/survey/${data.id}/statistics`, {params:data}).then((response) => {
            commit(types.LOAD_QVCT_SURVEY_REPORT, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


